import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DocumentValidationResult } from "src/app/domain/models/DocumentValidationResult";
import { OperationDocumentType } from "src/app/domain/models/Operation";

@Injectable({providedIn: 'root'})
export abstract class OperationDocumentTypeGateway {
  abstract getAll(): Observable<OperationDocumentType[]>
  abstract getAllQcType(): Observable<OperationDocumentType[]>
  abstract validateOperationDocument(operationDocumentGuid: string): Observable<DocumentValidationResult>
}
